import { Anchor, Button, Group, Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { i18nKeys, useTranslation } from 'locales';
import { useState } from 'react';

import { TwikeyMandateResponseSchema, useCreateTwikeyMandate } from '../api';

export const TwikeyModal = () => {
  const { t, currentLang } = useTranslation();
  const { createTwikeyMandate, isCreateTwikeyMandateLoading } = useCreateTwikeyMandate();
  const [twikeyUrl, setTwikeyUrl] = useState<string | null>(null);

  const requestMandate = () => {
    createTwikeyMandate(
      { locale: currentLang },
      {
        onSuccess: response => {
          setTwikeyUrl(TwikeyMandateResponseSchema.parse(response.data).twikeyUrl);
        },
      },
    );
  };

  if (twikeyUrl) {
    return (
      <Text>
        {t(i18nKeys.ONBOARDING[1].DIRECT_DEBIT.TO_CONTINUE)}{' '}
        <Anchor href={twikeyUrl} target="_blank" rel="noreferrer" onClick={() => modals.closeAll()}>
          {t(i18nKeys.ONBOARDING[1].DIRECT_DEBIT.CLICK_ON_LINK)}
        </Anchor>
      </Text>
    );
  }

  return (
    <Stack>
      <Text>{t(i18nKeys.ONBOARDING[1].DIRECT_DEBIT.CONFIRM)}</Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={() => modals.closeAll()}>
          {t(i18nKeys.NO)}
        </Button>
        <Button onClick={requestMandate} loading={isCreateTwikeyMandateLoading}>
          {t(i18nKeys.YES)}
        </Button>
      </Group>
    </Stack>
  );
};
